import React from "react";
import ReactDOM from "react-dom/client";
import store from "./store";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import { LicenseInfo } from "@mui/x-license";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
      userPoolClientId: `${process.env.REACT_APP_CLIENT_ID}`,
    },
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: `${process.env.REACT_APP_COOKIE_DOMAIN}`,
    secure: `${process.env.REACT_APP_COOKIE_SECURE}` === "true",
    path: `${process.env.REACT_APP_COOKIE_PATH}`,
    expires: +`${process.env.REACT_APP_COOKIE_DOMAIN}`,
  })
);

LicenseInfo.setLicenseKey(`${process.env.REACT_APP_MUI_X_LICENSE_KEY}`);

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

serviceWorker.unregister();
